var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 32 26",
  "content": "<symbol viewBox=\"0 0 32 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkmark\">\n    <path d=\"M29.1985 2.5L14.3284 23.3701L2.56162 10.7399\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol